import { Building2 } from 'lucide-react';
import OrganizationsTab from '@/components/admin/config/OrganizationsTab';

export default function OrganizationsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Building2 className="w-7 h-7 text-primary" />
        <div>
          <h1 className="text-2xl font-bold text-foreground">Organizaciones</h1>
          <p className="text-muted-foreground">Gestión de empresas cliente registradas en la plataforma</p>
        </div>
      </div>
      <OrganizationsTab />
    </div>
  );
}
